/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCreditVariantDto } from '../../models/backend-credit-variant-dto';
import { BackendPatchedCreditVariantRequestDto } from '../../models/backend-patched-credit-variant-request-dto';

export interface FinancingSourcesCreditsVariantsPartialUpdate$Params {
  /**
   * A unique integer value identifying this credit variant.
   */
  id: number;
  body?: BackendPatchedCreditVariantRequestDto;
}

export function financingSourcesCreditsVariantsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesCreditsVariantsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesCreditsVariantsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCreditVariantDto>;
    }),
  );
}

financingSourcesCreditsVariantsPartialUpdate.PATH = '/api/financing_sources/credits_variants/{id}/';
